import { Routes } from '@angular/router';

import { NotFoundComponent } from '../components/pages/not-found/not-found.component';
import { ErrorComponent } from '../components/pages/error/error.component';
import { SessionComponent } from '../components/pages/session/session.component';
import { MaintenanceComponent } from '../components/pages/maintenance/maintenance.component';
import { DevelopComponent } from '../components/pages/develop/develop.component';

var baseRoutes: Routes = [
    { path: 'error', component: ErrorComponent },
    { path: 'session', component: SessionComponent },
    { path: 'maintenance', component: MaintenanceComponent },
    { path: 'develop', component: DevelopComponent },
    { path: '**', component: NotFoundComponent },
];

export default baseRoutes;
